import { render, staticRenderFns } from "./CarbonButton.vue?vue&type=template&id=c72d2a2e&scoped=true"
import script from "./CarbonButton.vue?vue&type=script&lang=js"
export * from "./CarbonButton.vue?vue&type=script&lang=js"
import style0 from "./CarbonButton.vue?vue&type=style&index=0&id=c72d2a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72d2a2e",
  null
  
)

export default component.exports